/* import __COLOCATED_TEMPLATE__ from './plus-badge-wrapper.hbs.js'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();